import React, { useState } from "react";
import { X } from "lucide-react";
import { useCbomContext } from "../../context/CbomContext";
import UploadAgent from "../UploadAgent";
import DevicesUsingSensorAgent from "../DevicesUsingSensorAgent";

const UploadSensorAgent: React.FC = () => {
  const { setShowAgentUploadForm } = useCbomContext();
  return (
    <>
      <div className="max-h-full">
        <div
          className={
            "p-10 fixed inset-0 z-20 bg-gray-600 bg-opacity-50 overflow-hidden w-screen max-h-screen flex items-center justify-center"
          }
        >
          <div className="w-full p-2 bg-white rounded-lg flex flex-col max-h-full">
            <div className="flex justify-between items-center mb-4">
              <h1 className="text-xl font-bold text-custom-blue7 pl-2">
                Upload Sensor Agent
              </h1>
              <button
                className="p-2 bg-custom-blue7 rounded-full"
                onClick={() => {
                  setShowAgentUploadForm(false);
                }}
              >
                <X size={20} className="text-gray-50" />
              </button>
            </div>
            <div className="flex h-auto overflow-auto">
              <UploadAgent />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadSensorAgent;
